// extracted by mini-css-extract-plugin
export default {"explanation":"CodeToColor_explanation__y-pMU","codeAndButton":"CodeToColor_codeAndButton__vcuKY","code":"CodeToColor_code__9rxai","copyButton":"CodeToColor_copyButton__ltmjc"};